export enum KeyDirections {
  ARROW_RIGHT = 39,
  ARROW_LEFT = 37,
  ARROW_DOWN = 40,
  ARROW_UP = 38,
  ENTER = 13,
  ESCAPE = 27,
  PAGE_DOWN = 34,
  PAGE_UP = 33,
  PLAY_PAUSE = 250,
  FORWARD = 228,
  REWIND = 227,
  PLAY_PAUSE_ON_KEYBOARD = 32,
  FAST_FORWARD_ON_KEYBOARD = 70,
  REWIND_ON_KEYBOARD = 82
}
